import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import axios from "axios";
import "swiper/css";
import "swiper/css/navigation";
import { MyApi } from "../../MyApi";
const Banner = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + MyApi.BANNER_LIST, {
          headers: {
            Authorization: MyApi.SECRET_KEY,
          },
        });

        if (res.data?.status) {
          setBanners(res.data.data);
        }
      } catch (err) {
        console.error("Banner API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  if (loading) {
    return <div className="p-5 text-center">Loading banners...</div>;
  }

  if (!banners.length) {
    return <div className="p-5 text-center">No banners found</div>;
  }

  return (
    <div className="banner_style">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        speed={1200}
        grabCursor
        loop
        className="banner-swiper"
      >
        {banners.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="banner-slide">
              <img
                src={item.banner_url}
                alt={item.title}
                className="banner-img"
              />
                {(item?.bannertitle || item?.bannerhortcontent) && (
                <div className="banner-text">
                  {item?.bannertitle && (
                    <h2 className="animate-title">{item.bannertitle}</h2>
                  )}

                  {item?.bannerhortcontent && (
                    <p className="animate-sub">{item.bannerhortcontent}</p>
                  )}
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Banner;
